// extracted by mini-css-extract-plugin
export default {"productCarousel":"V9-z"};